// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3zWWq","description":"PatientConsentPreview_description__29H8n"};